// NAVIGATION TYPES
export interface NavItem {
  label: string;
  path?: string;
  icon?: string;
  children?: { label: string; path: string }[];
}

// NAVIGATION ITEMS
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/Admin/Dashboard', icon: 'dashboard' },
  {
    label: 'Users',
    icon: 'users',
    children: [
      { label: 'Players', path: '/Admin/Users/Players' },
      { label: 'Administrators', path: '/Admin/Users/Administrators' },
      { label: 'Roles', path: '/Admin/Users/Roles' },
    ],
  },
  { label: 'Notifications', path: '/Admin/Notifications', icon: 'notification' },
  { label: 'Promotions', path: '/Admin/Promotions', icon: 'gift' },
  { label: 'Tutorials', path: '/Admin/Tutorials', icon: 'video' },
  {
    label: 'Operations',
    icon: 'tool',
    children: [
      { label: 'Account Deletions', path: '/Admin/Operations/AccountDeletions' },
      { label: 'Bot Queue', path: '/Admin/Operations/BotQueue' },
    ],
  },
  { label: 'Logout', path: '/Logout', icon: 'logout' },
];